/* NATION — interacciones. Vanilla, sin librerias.
   Guard de ejecucion unica + inits idempotentes (el editor de Shopify
   vuelve a renderizar secciones sin recargar la pagina). */
(function () {
  if (window.__ntInit) return;
  window.__ntInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarse = window.matchMedia('(pointer: coarse)').matches;
  var hasIO = 'IntersectionObserver' in window;     // navegadores muy viejos: se muestra todo sin animar
  /* 2026-10-10: con 'reducir movimiento' del sistema ya NO se apaga todo; se usa un modo calmado
     (solo fundidos suaves, sin desplazamientos grandes) para que la página no se vea estática. */
  if (reduce) document.documentElement.classList.add('nt-calm');

  /* ---------- Reveals al entrar en pantalla ---------- */
  var revealObserver = null;
  function initReveals() {
    var items = document.querySelectorAll('.nt-reveal:not([data-nt-rev])');
    if (!items.length) return;
    if (!hasIO) {
      items.forEach(function (el) { el.dataset.ntRev = '1'; el.classList.add('nt-visible'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('nt-visible');
          revealObserver.unobserve(e.target);
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    }
    items.forEach(function (el) { el.dataset.ntRev = '1'; revealObserver.observe(el); });
    // Red de seguridad: si por cualquier motivo el observador no dispara, lo que ya está a la vista se muestra igual.
    setTimeout(function () {
      document.querySelectorAll('.nt-reveal:not(.nt-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.05 && r.bottom > 0) el.classList.add('nt-visible');
      });
    }, 2500);
  }

  /* ---------- Hero: foco que sigue al raton + inclinacion del producto ---------- */
  function initHero() {
    document.querySelectorAll('.nt-hero:not([data-nt-init])').forEach(function (hero) {
      hero.dataset.ntInit = '1';
      var glow = hero.querySelector('.nt-hero__glow');
      var img = hero.querySelector('.nt-hero__img');
      if (reduce || coarse) return;
      var raf = null, mx = 62, my = 42, rx = 0, ry = 0;
      hero.addEventListener('mousemove', function (ev) {
        var r = hero.getBoundingClientRect();
        mx = ((ev.clientX - r.left) / r.width) * 100;
        my = ((ev.clientY - r.top) / r.height) * 100;
        ry = ((ev.clientX - r.left) / r.width - 0.5) * 12;
        rx = -((ev.clientY - r.top) / r.height - 0.5) * 8;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          if (glow) glow.style.setProperty('--nt-mx', mx.toFixed(1) + '%');
          if (glow) glow.style.setProperty('--nt-my', my.toFixed(1) + '%');
          if (img) {
            img.style.setProperty('--nt-ry', ry.toFixed(2) + 'deg');
            img.style.setProperty('--nt-rx', rx.toFixed(2) + 'deg');
          }
        });
      });
      hero.addEventListener('mouseleave', function () {
        if (glow) { glow.style.setProperty('--nt-mx', '62%'); glow.style.setProperty('--nt-my', '42%'); }
        if (img) { img.style.setProperty('--nt-ry', '0deg'); img.style.setProperty('--nt-rx', '0deg'); }
      });
    });
  }

  /* ---------- Mapa de puntos de dolor ---------- */
  function initPainMap() {
    document.querySelectorAll('.nt-map:not([data-nt-init])').forEach(function (map) {
      map.dataset.ntInit = '1';
      var hots = map.querySelectorAll('.nt-map__hot');
      var cards = map.querySelectorAll('.nt-map__card');
      function select(i) {
        hots.forEach(function (h, n) { h.setAttribute('aria-expanded', n === i ? 'true' : 'false'); });
        cards.forEach(function (c, n) { c.classList.toggle('is-active', n === i); });
      }
      hots.forEach(function (h, i) {
        h.addEventListener('click', function () { select(i); });
        h.addEventListener('mouseenter', function () { if (!coarse) select(i); });
      });
      cards.forEach(function (c, i) {
        c.addEventListener('mouseenter', function () { if (!coarse) select(i); });
        c.addEventListener('click', function () { select(i); });
      });
      select(0);
    });
  }

  /* ---------- Posiciones de uso (pestanas) ---------- */
  function initPositions() {
    document.querySelectorAll('.nt-pos:not([data-nt-init])').forEach(function (pos) {
      pos.dataset.ntInit = '1';
      var tabs = pos.querySelectorAll('.nt-pos__tab');
      var imgs = pos.querySelectorAll('.nt-pos__frame img');
      var texts = pos.querySelectorAll('.nt-pos__panel');
      function show(i) {
        tabs.forEach(function (t, n) {
          t.classList.toggle('is-active', n === i);
          t.setAttribute('aria-selected', n === i ? 'true' : 'false');
        });
        imgs.forEach(function (m, n) { m.classList.toggle('is-active', n === i); });
        texts.forEach(function (p, n) { p.hidden = n !== i; });
      }
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      show(0);
    });
  }

  /* ---------- Anillo de minutos ---------- */
  var ringObserver = null;
  function initRings() {
    var rings = document.querySelectorAll('.nt-min__ring:not([data-nt-init])');
    if (!rings.length) return;
    if (!hasIO) {
      rings.forEach(function (r) { r.dataset.ntInit = '1'; r.classList.add('is-on'); countUp(r.querySelector('[data-nt-count]')); });
      return;
    }
    if (!ringObserver) {
      ringObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-on');
          countUp(e.target.querySelector('[data-nt-count]'));
          ringObserver.unobserve(e.target);
        });
      }, { threshold: 0.4 });
    }
    rings.forEach(function (r) { r.dataset.ntInit = '1'; ringObserver.observe(r); });
  }

  function countUp(el) {
    if (!el) return;
    var target = parseFloat(el.dataset.ntCount || '0');
    if (reduce) { el.textContent = String(target); return; }
    el.textContent = '0';
    var start = null, dur = 1400;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = String(Math.round(target * eased));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- FAQ ---------- */
  function initFaq() {
    document.querySelectorAll('.nt-faq:not([data-nt-init])').forEach(function (faq) {
      faq.dataset.ntInit = '1';
      faq.querySelectorAll('.nt-faq__q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.nt-faq__item');
          var open = item.classList.contains('is-open');
          if (faq.dataset.ntSolo === '1') {
            faq.querySelectorAll('.nt-faq__item').forEach(function (o) {
              o.classList.remove('is-open');
              o.querySelector('.nt-faq__q').setAttribute('aria-expanded', 'false');
            });
          }
          item.classList.toggle('is-open', !open);
          btn.setAttribute('aria-expanded', String(!open));
        });
      });
    });
  }

  /* ---------- Boton magnetico ---------- */
  function initMagnetic() {
    if (reduce || coarse) return;
    document.querySelectorAll('[data-nt-magnetic]:not([data-nt-init])').forEach(function (btn) {
      btn.dataset.ntInit = '1';
      btn.addEventListener('mousemove', function (ev) {
        var r = btn.getBoundingClientRect();
        var x = (ev.clientX - r.left - r.width / 2) * 0.16;
        var y = (ev.clientY - r.top - r.height / 2) * 0.24;
        btn.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* ---------- Galeria de la pagina de producto ---------- */
  function initPdpGallery() {
    document.querySelectorAll('.nt-pdp__gallery:not([data-nt-init])').forEach(function (g) {
      g.dataset.ntInit = '1';
      var main = g.querySelector('.nt-pdp__main img');
      var thumbs = g.querySelectorAll('.nt-pdp__thumb');
      if (!main) return;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var src = t.dataset.ntSrc;
          if (src) main.src = src;
          thumbs.forEach(function (o) { o.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    });
  }



  /* ---------- Flechas izquierda/derecha para cualquier carril horizontal (2026-10-10) ----------
     Regla de diseño: todo bloque donde se mueven imágenes de lado a lado lleva flechas visibles. */
  function addRailArrows(track) {
    if (track.parentNode.classList.contains('nt-rail__wrap')) return;
    var wrap = document.createElement('div');
    wrap.className = 'nt-rail__wrap';
    track.parentNode.insertBefore(wrap, track);
    wrap.appendChild(track);
    function mk(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nt-rail__arrow nt-rail__arrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous' : 'Next');
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="' +
        (dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') +
        '" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      wrap.appendChild(b);
      return b;
    }
    var prev = mk('prev'), next = mk('next');
    function paso() {
      var it = track.querySelector('.nt-rail__item');
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 18;
      return it ? it.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    }
    function ir(signo) {
      var left = track.scrollLeft + signo * paso();
      if (track.scrollTo) track.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
      else track.scrollLeft = left;
    }
    prev.addEventListener('click', function () { ir(-1); });
    next.addEventListener('click', function () { ir(1); });
    function estado() {
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
      wrap.classList.toggle('has-overflow', max > 4);
      var media = track.querySelector('.nt-rail__media');
      if (media) wrap.style.setProperty('--nt-arrow-top', (media.offsetHeight / 2) + 'px');
    }
    track.addEventListener('scroll', estado, { passive: true });
    window.addEventListener('resize', estado);
    window.addEventListener('load', estado);
    estado();
    setTimeout(estado, 700);
  }

  /* ---------- Carril arrastrable con inercia ---------- */
  function initRail() {
    document.querySelectorAll('.nt-rail__track:not([data-nt-init])').forEach(function (track) {
      track.dataset.ntInit = '1';
      var barra = track.parentElement.querySelector('.nt-rail__bar i');
      function pintaBarra() {
        if (!barra) return;
        var max = track.scrollWidth - track.clientWidth;
        var visible = track.clientWidth / track.scrollWidth * 100;
        barra.style.width = Math.max(12, visible).toFixed(1) + '%';
        var p = max > 0 ? track.scrollLeft / max : 0;
        var recorrido = 100 - Math.max(12, visible);
        barra.style.transform = 'translateX(' + (p * recorrido / Math.max(12, visible) * 100).toFixed(1) + '%)';
      }
      track.addEventListener('scroll', pintaBarra, { passive: true });
      window.addEventListener('resize', pintaBarra);
      pintaBarra();
      addRailArrows(track);

      if (coarse) return;                      // en táctil el scroll nativo ya va bien
      var abajo = false, xIni = 0, sIni = 0, movido = 0;
      track.addEventListener('mousedown', function (ev) {
        abajo = true; movido = 0;
        xIni = ev.pageX; sIni = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      window.addEventListener('mouseup', function () {
        if (!abajo) return;
        abajo = false; track.classList.remove('is-dragging');
      });
      track.addEventListener('mousemove', function (ev) {
        if (!abajo) return;
        ev.preventDefault();
        var d = ev.pageX - xIni;
        movido = Math.abs(d);
        track.scrollLeft = sIni - d;
      });
      track.addEventListener('click', function (ev) {
        if (movido > 6) { ev.preventDefault(); ev.stopPropagation(); }
      }, true);
    });
  }

  /* ---------- Línea de progreso semana a semana ---------- */
  var progObserver = null;
  function initProgreso() {
    var lineas = document.querySelectorAll('.nt-prog__line:not([data-nt-init])');
    if (!lineas.length) return;
    if (!hasIO) { lineas.forEach(function (l) { l.dataset.ntInit = '1'; l.style.setProperty('--nt-avance', '100%'); }); return; }
    if (!progObserver) {
      progObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.style.setProperty('--nt-avance', '100%');
          progObserver.unobserve(e.target);
        });
      }, { threshold: 0.25 });
    }
    lineas.forEach(function (l) {
      l.dataset.ntInit = '1';
      if (reduce) { l.style.setProperty('--nt-avance', '100%'); return; }
      progObserver.observe(l);
    });
  }

  /* ---------- Fechas de entrega estimadas (honestas: hoy + días hábiles) ---------- */
  function initEntrega() {
    document.querySelectorAll('[data-nt-entrega]:not([data-nt-init])').forEach(function (el) {
      el.dataset.ntInit = '1';
      var dias = parseInt(el.dataset.ntEntrega, 10);
      if (isNaN(dias)) return;
      var f = new Date();
      var sumados = 0;
      while (sumados < dias) {
        f.setDate(f.getDate() + 1);
        var d = f.getDay();
        if (d !== 0 && d !== 6) sumados++;      // solo días laborables
      }
      try {
        el.textContent = f.toLocaleDateString(document.documentElement.lang || 'en-US',
          { weekday: 'long', month: 'long', day: 'numeric' });
      } catch (e) { /* si el idioma no existe, se queda el texto de respaldo */ }
    });
  }

  function initAll() {
    // Cada bloque va aislado: si uno falla en un navegador raro, el resto sigue funcionando.
    [initReveals, initHero, initPainMap, initPositions, initRings, initFaq,
     initMagnetic, initPdpGallery, initRail, initProgreso, initEntrega].forEach(function (fn) {
      try { fn(); } catch (e) { if (window.console) console.warn('[nt] ' + (fn.name || 'init') + ':', e); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
